import React from "react";
import Graphic from "../../../assets/images/Link14.svg";

const HUF = () => {
  return (
    <div className="bg-[#F1EBF3] max-w-[100vw] p-4 lg:px-4 relative">
      <div className="flex gap-2 items-center flex-wrap py-4">
        <svg
          width="34"
          height="17"
          viewBox="0 0 34 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 8.5C0 13.1944 3.80558 17 8.5 17V0C3.80558 0 0 3.80558 0 8.5Z"
            fill="#6F368B"
          />
          <path
            d="M8.5 8.5C8.5 13.1944 12.3056 17 17 17V0C12.3056 0 8.5 3.80558 8.5 8.5Z"
            fill="#6F368B"
          />
          <circle cx="25.5" cy="8.5" r="8.5" fill="#6F368B" />
        </svg>
        <p className="text-[20px] font-semibold text-black text-left flex items-center gap-2">
          {/* For Individuals & HUF */}
          FORM NO 93 ( for Individuals) for citizen of India
        </p>
      </div>

      <div className="bg-white overflow-hidden mt-4 shadow-sm rounded-lg">
        {/* <h6 className="text-[#6F368B] text-lg font-bold mb-4 uppercase">FORM 93 – For Individual (Citizen of India)</h6> */}
        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse border border-gray-300 text-[12px] md:text-[14px]">
            <thead className="bg-[#E9E1EE]">
              <tr>
                <th className="p-3 border text-center font-bold">SR NO</th>
                <th className="p-3 border text-left font-bold">Nature of Documents</th>
                <th className="p-3 border text-center font-bold">Proof of Identity</th>
                <th className="p-3 border text-center font-bold">Proof of Address</th>
                <th className="p-3 border text-center font-bold">DOB (Bearing the name, date, month and year of Birth)</th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-gray-100"><td colSpan="5" className="p-2 border font-bold">A. Copy of :-</td></tr>
              {[
                { sr: "1", doc: "AADHAAR Card issued by the Unique Identification Authority of India;", poi: "Yes", poa: "Yes", dob: <mark>No</mark> },
                { sr: "2", doc: "Indian Passport;", poi: "Yes", poa: "Yes", dob: "Yes" },
                { sr: "3", doc: "Driving licence;", poi: "Yes", poa: "Yes", dob: "Yes" },
                { sr: "4", doc: "Elector’s photo identity card issued by the Election Commission of India;", poi: "Yes", poa: "Yes", dob: "Yes" },
                { sr: "5", doc: "Ration card having photograph of the applicant;", poi: "Yes", poa: "No", dob: "No" },
                { sr: "6", doc: "Transgender Identity Card / Certificate issued under the Transgender Persons (Protection of Rights) Act, 2019 having photograph of the applicant;", poi: "Yes", poa: "Yes", dob: "Yes" },
                { sr: "7", doc: "Photo identity card issued by the Central Government or a State Government or a Public Sector Undertaking;", poi: "Yes", poa: "No", dob: "Yes" },
                { sr: "8", doc: "Pensioner Card issued by Government having photograph of the applicant;", poi: "Yes", poa: "No", dob: "No" },
                { sr: "9", doc: "Central Government Health Scheme Card or Ex-servicemen Contributory Health Scheme photo card;", poi: "Yes", poa: "No", dob: "Yes" },
                { sr: "10", doc: "Indian Passport of the spouse;", poi: "No", poa: "Yes", dob: "No" },
                { sr: "11", doc: "Post office passbook having address of the applicant;", poi: "No", poa: "Yes", dob: "No" },
                { sr: "12", doc: "Domicile certificate issued by the Government;", poi: "No", poa: "Yes", dob: "Yes" },
                { sr: "13", doc: "Allotment letter of accommodation issued by the Central Government or State Government of not more than three years old;", poi: "No", poa: "Yes", dob: "No" },
                { sr: "14", doc: "Property registration document", poi: "No", poa: "Yes", dob: "No" },
                { sr: "15", doc: "Latest property tax assessment order", poi: "No", poa: "Yes", dob: "No" },
                { sr: "16", doc: "Electricity bill (Not more than three months old)", poi: "No", poa: "Yes", dob: "No" },
                { sr: "17", doc: "Landline telephone or broadband connection bill (Not more than three months old)", poi: "No", poa: "Yes", dob: "No" },
                { sr: "18", doc: "Water bill (Not more than three months old)", poi: "No", poa: "Yes", dob: "No" },
                { sr: "19", doc: "Consumer gas connection card or book or piped gas bill (Not more than three months old)", poi: "No", poa: "Yes", dob: "No" },
                { sr: "20", doc: "Bank account statement (Not more than three months old)", poi: "No", poa: "Yes", dob: "No" },
                { sr: "21", doc: "Depository account statement (Not more than three months old)", poi: "No", poa: "Yes", dob: "No" },
                { sr: "22", doc: "Credit card statement (Not more than three months old)", poi: "No", poa: "Yes", dob: "No" },
                { sr: "23", doc: "For Individuals born on and after 01.10.2023, copy of birth certificate issued by the municipal authority or any office authorised to issue birth and death certificate by the Registrar of Birth and Deaths or the Indian Consulate as defined in clause (d) of sub-section (1) of section 2 of the Citizenship Act, 1955 (57 of 1955) is mandatory", poi: "No", poa: "No", dob: "Yes" },
                { sr: "24", doc: "Birth certificate issued by the municipal authority or any office authorised to issue birth and death certificate by the Registrar of Birth and Deaths or the Indian Consulate as defined in clause (d) of sub-section (1) of section 2 of the Citizenship Act, 1955 (57 of 1955)", poi: "No", poa: "No", dob: "Yes" },
                { sr: "25", doc: "Pension payment order", poi: "No", poa: "No", dob: "Yes" },
                { sr: "26", doc: "Marriage certificate issued by the Registrar of Marriages", poi: "No", poa: "No", dob: "Yes" },
                { sr: "27", doc: "Matriculation certificate or mark sheet of recognised board;", poi: "No", poa: "No", dob: "Yes" },
              ].map((item, idx) => (
                <tr key={idx} className="hover:bg-gray-50 text-[#4B4B4B]">
                  <td className="p-2 border text-center">{item.sr}</td>
                  <td className="p-2 border">{item.doc}</td>
                  <td className="p-2 border text-center">{item.poi}</td>
                  <td className="p-2 border text-center">{item.poa}</td>
                  <td className="p-2 border text-center">{item.dob}</td>
                </tr>
              ))}
              <tr className="bg-gray-100"><td colSpan="5" className="p-2 border font-bold">B. Or Original of :-</td></tr>
              {[
                { sr: "1", doc: "Certificate of identity signed by a Member of Parliament or Member of Legislative Assembly or Municipal Councilor or a Gazetted Officer, as the case may be (Annexure A)", poi: "Yes", poa: "No", dob: "No" },
                { sr: "2", doc: "Bank certificate on letter head from the branch (along with the name, stamp and copy of employee ID of the issuing officer) containing duly attested photograph and bank account number of the applicant (Annexure C)", poi: "Yes", poa: "No", dob: "No" },
                { sr: "3", doc: "Certificate of address signed by a Member of Parliament or Member of Legislative Assembly or Municipal Councilor or a Gazetted Officer, as the case may be (Annexure A)", poi: "No", poa: "Yes", dob: "No" },
                { sr: "4", doc: "Employer certificate (Annexure B)", poi: "No", poa: "Yes", dob: "No" },
                { sr: "5", doc: "Original affidavit sworn before a magistrate stating the date of birth.", poi: "No", poa: "No", dob: "Yes" },
              ].map((item, idx) => (
                <tr key={idx} className="hover:bg-gray-50 text-[#4B4B4B]">
                  <td className="p-2 border text-center">{item.sr}</td>
                  <td className="p-2 border">{item.doc}</td>
                  <td className="p-2 border text-center">{item.poi}</td>
                  <td className="p-2 border text-center">{item.poa}</td>
                  <td className="p-2 border text-center">{item.dob}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-4 text-[10px] md:text-xs space-y-2 text-gray-700 italic">
          <p><strong>Note 1:</strong> In case of a person being a minor, in addition to Aadhaar of the minor, any of the above listed documents of any of the parents or guardian of such minor shall be deemed to be the proof of identity.</p>
          <p><strong>Note 2:</strong> In case of an Indian citizen residing outside India, copy of bank account statement in country of residence or copy of non-resident external bank account statements shall be the proof of address.</p>
          <p><strong>Note 3:</strong> In case of a minor, any of the above listed documents of any of the parents or guardian of such minor shall be deemed to be the proof of address</p>
        </div>
      </div>

      <img 
        src={Graphic} 
        alt="protean" 
        className="absolute bottom-0 right-0 hidden lg:flex opacity-20 pointer-events-none w-[150px] md:w-[200px]" 
      />
    </div>
  );
};

export default HUF;